module.exports = __webpack_public_path__ + "img/ico-defensivos.e6bcd84c.png";